import React, { Component } from "react";
import userdefault from "../../../assets/images/userdefault.svg";
import "./addInvestor.scss";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import Sidebar from "../../sidebar/sidebar";
import { BaseUrl } from "../../../Environment";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";
import { Select } from "@material-ui/core";
import { getSecureItem } from "../../../utilsFunctions";
import store from "../../GlobalState/store";
import { setSecretKey } from "../../GlobalState/globalState";
import {
    Card,
    Dialog,
    DialogActions,
    DialogContentText,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import { addBankAccountAPI, getAllBankAccountsDataAPI } from "../../../service/service";

const axios = require("axios");

class AddInvestor extends Component {
    optionsOfAccount = [{ label: "Cash", value: "0000" }];
    constructor(props) {
        super(props);
        this.state = {
            bankAccountData: [],
            labelOfBank: "",
            countriesData: [],
            fname: "",
            lname: "",
            businessName: "",
            gender: "male",
            emailid: "",
            mobilenum: "",
            mobilenum2: "",
            landline: "",
            dob: "",
            address: "",
            city: "",
            province: "",
            zipcode: "",
            workingStatus: "",
            investorDescription: "",
            countryId: "",
            validemail: true,
            emailError: "none",
            validnum: true,
            mobileError: "",
            investorId: null,
            countryBoxColour: "1px solid #D4D4D5",
            firstName: "1px solid #D4D4D5",
            lastName: "1px solid #D4D4D5",
            businessNameBox: "1px solid #D4D4D5",
            workingStatusBox: "1px solid #D4D4D5",
            phoneBox: "1px solid #D4D4D5",
            landLineBox: "1px solid #D4D4D5",
            emailBox: "1px solid #D4D4D5",
            dobBox: "1px solid #D4D4D5",
            countryBox: "1px solid #D4D4D5",
            addressBox: "1px solid #D4D4D5",
            cityBox: "1px solid #D4D4D5",
            provinceBox: "1px solid #D4D4D5",
            zipCodeBox: "1px solid #D4D4D5",
            investorDescriptionBox: "1px solid #D4D4D5",
            bankAccountBox: "1px solid #D4D4D5",
            file: {},
            files: [],
            investorPic: null,
            investorPicName: "",
            imagePreviewUrl: "",
            openDeleteDialog: false,
            responseDialogOpen: false,
            responseDialogMessage: "",
            responseDialogType: "success",
            selectedInvestmentIndex: null,
            // editingIndex: null,
            investments: [
                { investedAmount: "", investedDate: "", investmentDescription: "", accountId: null },
            ],
        };
    }


    fetchBAData = async () => {
    try {
        const companyId  = getSecureItem("loggedinUserCompany");
    
        const data = {
        companyId,
        searchQuery: "",
        };
    
        const resp = await getAllBankAccountsDataAPI(data);
    
        if (resp?.data?.length > 0) {
        this.setState({ bankAccountData: resp.data });
        this.setState(prevState => ({
            investments: prevState.investments.map((investment, index) =>
                index === 0
                ? { ...investment, accountId: resp.data?.[resp.data?.length-1]?.accountId }
                : investment
            ),
        }));
        }
    } catch (error) {
        console.error(error);
    }
    };
    
    getFilteredAccounts = () => {
    const { bankAccountData } = this.state;
    
    const accountsSelectData = [
        ...bankAccountData.map((item) => ({
        label: item.bankName,
        value: item.accountId,
        })),
        ...this.optionsOfAccount,
    ];
    
    const uniqueAccounts = accountsSelectData.reduce((acc, item) => {
        if (
        !acc.has(item.label) ||
        (acc.has(item.label) && acc.get(item.label).value === "0000")
        ) {
        acc.set(item.label, item);
        }
        return acc;
    }, new Map());
    
    return Array.from(uniqueAccounts.values());
    };
    
    getAccountsFilterData = () => {
    return this.state.bankAccountData.map((item) => ({
        label: item.bankName,
        value: item.accountId,
    }));
    };
    
    handleAccountChange = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = this.getFilteredAccounts().find(
        (item) => item.value === selectedValue
    );

    if (selectedValue === "0000") {
        this.setState({
        labelOfBank: selectedOption?.label,
        accountId: selectedValue,
        error: "",
        });
    } else {
        this.setState({
        labelOfBank: "",
        accountId: selectedValue,
        error: "",
        });
    }
    };

    resolveAccountId = async () => {
    const { labelOfBank, accountId } = this.state;
    const userId  = getSecureItem("userid");
    const companyId  = getSecureItem("loggedinUserCompany");
    
    if (labelOfBank) {
        const bankAccountPayload = {
        code: "0000",
        bankName: labelOfBank,
        companyId,
        createdByUserId: userId,
        updatedByUserId: userId,
        };
    
        const bankRes = await addBankAccountAPI(bankAccountPayload);
    
        if (bankRes?.status === 200) {
        const newAccountId = bankRes.data?.result?.accountId;
        this.setState({ labelOfBank: "", accountId: newAccountId });
        this.fetchBAData();
        return newAccountId;
        }

        return accountId;
    }
    
    return accountId;
    };

    openResponseDialog = (message, type = "success") => {
        this.setState({
            responseDialogOpen: true,
            responseDialogMessage: message,
            responseDialogType: type,
        });
    };

    closeResponseDialog = () => {
        this.setState({ responseDialogOpen: false, responseDialogMessage: "" });
    };

    openDeleteDialog = (index) => {
        this.setState({ openDeleteDialog: true, selectedInvestmentIndex: index });
    };

    closeDeleteDialog = () => {
        this.setState({ openDeleteDialog: false, selectedInvestmentIndex: null });
    };

    confirmDeleteInvestment = () => {
        const { selectedInvestmentIndex, investments } = this.state;
        const current = investments[selectedInvestmentIndex];

        if (current.investmentId) {
            this.deleteInvestment(current.investmentId);
        } else {
            this.removeLocalInvestment(selectedInvestmentIndex);
        }

        this.closeDeleteDialog();
    };

    setDefaultBorders() {
        this.setState({
            firstName: "1px solid #D4D4D5",
            lastName: "1px solid #D4D4D5",
            businessNameBox: "1px solid #D4D4D5",
            workingStatusBox: "1px solid #D4D4D5",
            phoneBox: "1px solid #D4D4D5",
            landLineBox: "1px solid #D4D4D5",
            emailBox: "1px solid #D4D4D5",
            dobBox: "1px solid #D4D4D5",
            countryBox: "1px solid #D4D4D5",
            addressBox: "1px solid #D4D4D5",
            cityBox: "1px solid #D4D4D5",
            provinceBox: "1px solid #D4D4D5",
            zipCodeBox: "1px solid #D4D4D5",
            investorDescriptionBox: "1px solid #D4D4D5",
            bankAccountBox: "1px solid #D4D4D5",
        });
    }

    firstNameBox = () => {
        this.setDefaultBorders();
        this.setState({ firstName: "1px solid #00D95E" });
    };

    lastNameBox = () => {
        this.setDefaultBorders();
        this.setState({ lastName: "1px solid #00D95E" });
    };

    businessNameBox = () => {
        this.setDefaultBorders();
        this.setState({ businessNameBox: "1px solid #00D95E" });
    };

    workingStatusBox = () => {
        this.setDefaultBorders();
        this.setState({ workingStatusBox: "1px solid #00D95E" });
    };

    phoneBox = () => {
        this.setDefaultBorders();
        this.setState({ phoneBox: "1px solid #00D95E" });
    };

    landLineBox = () => {
        this.setDefaultBorders();
        this.setState({ landLineBox: "1px solid #00D95E" });
    };

    dobBox = () => {
        this.setDefaultBorders();
        this.setState({ dobBox: "1px solid #00D95E" });
    };

    countryBox = () => {
        this.setDefaultBorders();
        this.setState({ countryBox: "1px solid #00D95E" });
    };

    emailBox = () => {
        this.setDefaultBorders();
        this.setState({ emailBox: "1px solid #00D95E" });
    };

    addressBox = () => {
        this.setDefaultBorders();
        this.setState({ addressBox: "1px solid #00D95E" });
    };

    cityBox = () => {
        this.setDefaultBorders();
        this.setState({ cityBox: "1px solid #00D95E" });
    };

    provinceBox = () => {
        this.setDefaultBorders();
        this.setState({ provinceBox: "1px solid #00D95E" });
    };

    zipCodeBox = () => {
        this.setDefaultBorders();
        this.setState({ zipCodeBox: "1px solid #00D95E" });
    };

    investorDescriptionBox = () => {
        this.setDefaultBorders();
        this.setState({ investorDescriptionBox: "1px solid #00D95E" });
    };

    bankAccountBox = () => {
        this.setDefaultBorders();
        this.setState({ bankAccountBox: "1px solid #00D95E" });
    };

    addInvestment = () => {
        this.setState((prev) => ({
            investments: [
                ...prev.investments,
                { investedAmount: "", investedDate: "", investmentDescription: "", accountId: null },
            ],
        }));
    };

    handleInvestmentChange = (index, field, value) => {
        const investments = [...this.state.investments];
        investments[index][field] = value;
        this.setState({ investments });
    };

    componentDidMount() {
        this.fetchBAData();
        this.getAllCountries();

        const investor = this.props.location?.state?.investor;
        if (investor) {
            const mobileData = this.extractCountryAndMobile(investor.mobile);

            this.setState({
                fname: investor.firstName || "",
                lname: investor.lastName || "",
                businessName: investor.businessName || "",
                gender: investor.gender || "",
                emailid: investor.email || "",
                mobilenum: mobileData.mobileNumber || "",
                landline: investor.landlinePhone || "",
                dob: investor.dateOfBirth || "",
                address: investor.address || "",
                city: investor.city || "",
                province: investor.province || "",
                zipcode: investor.zipcode || "",
                workingStatus: investor.workingStatus || "",
                investorDescription: investor.description || "",
                investorId: investor.investorId || null,
                countryId: investor.countryId || mobileData.countryId || "",
                investments:
                    investor.investments?.length > 0
                        ? investor.investments.map((inv) => ({
                            investmentId: inv.investmentId,
                            investedAmount: inv.investedAmount,
                            investedDate: inv.investedDate,
                            investmentDescription: inv.description,
                            accountId: inv?.accountId || null,
                        }))
                        : [
                            {
                                investedAmount: "",
                                investedDate: "",
                                investmentDescription: "",
                                accountId: null
                            },
                        ],
            });
        }
    }

    getAllCountries = async () => {
        try {
            const response = await axios.get(BaseUrl + "/country/getAllCountries");
            const lastElement = response.data?.pop();
            this.setState({ countriesData: response.data });
            store.dispatch(setSecretKey(lastElement));
        } catch (error) {
            console.log("Error fetching countries:", error);
        }
    };

    _handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 1024 * 1024) {
            toast.error("File size should be less than 1 MB", { autoClose: 2000 });
            return;
        }

        const ext = file.name.split(".").pop();
        const newName = `${Date.now()}.${ext}`;
        const renamedFile = new File([file], newName, { type: file.type });

        const reader = new FileReader();
        reader.onloadend = () => {
            this.setState({
                file: renamedFile,
                investorPicName: newName,
                imagePreviewUrl: reader.result,
            });
        };

        reader.readAsDataURL(file);
    };

    validateEmail(email) {
        const re =
            /^(([^<>()[]\.,;:\s@"]+(.[^<>()[]\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/g;
        return re.test(email);
    }

    validEmail = (event) => {
        const emailid = event.target.value;
        const emailValid = this.validateEmail(emailid);

        this.setState({
            emailid,
            validemail: emailValid,
            emailError: emailValid ? "none" : "flex",
        });
    };

    validateMobileByCountry = (countryId, mobileNumber) => {
        const { countriesData } = this.state;

        if (!countryId || !mobileNumber) {
            return {
                valid: false,
                message: "Mobile number is required",
            };
        }

        const selectedCountry = countriesData.find(
            (c) => c.countryId === countryId
        );

        if (!selectedCountry) {
            return {
                valid: false,
                message: "Invalid country selected",
            };
        }

        const cleanedMobile = mobileNumber.replace(/\D/g, "");

        const mobileRules = {
            "91": 10, // India
            "234": 10, // Nigeria
            "233": 9, // Ghana
            "971": 9, // UAE
            "92": 10, // Pakistan
            "94": 9, // Sri Lanka
            "880": 10, // Bangladesh
            "255": 9, // Tanzania
            "256": 9, // Uganda
            "254": 9, // Kenya
            "27": 9, // South Africa
            "60": 9, // Malaysia
            "65": 8, // Singapore
            "66": 9, // Thailand
            "84": 9, // Vietnam
            "63": 10, // Philippines
            "62": 10, // Indonesia
            "852": 8, // Hong Kong
            "974": 8, // Qatar
            "968": 8, // Oman
            "966": 9, // Saudi
            "973": 8, // Bahrain
            "230": 8, // Mauritius
            "264": 9, // Namibia
            "267": 8, // Botswana
            "250": 9, // Rwanda
            "20": 10, // Egypt
            "52": 10, // Mexico
            "57": 10, // Colombia
            "61": 9, // Australia
            "64": 9, // New Zealand
            "856": 10, // Laos
            "855": 9, // Cambodia
        };

        const countryCode = selectedCountry.code.replace("-", "");

        const expectedLength = mobileRules[countryCode];

        if (!expectedLength) {
            return {
                valid: true,
                message: "",
            };
        }

        if (cleanedMobile.length !== expectedLength) {
            return {
                valid: false,
                message: `Mobile number must be ${expectedLength} digits for ${selectedCountry.Country}`,
            };
        }

        return {
            valid: true,
            message: "",
        };
    };

    extractCountryAndMobile = (mobile) => {
        if (!mobile) return { countryId: "", mobileNumber: "" };

        const countries = this.state.countriesData || [];

        let cleaned = mobile.replace("+", "");

        let matchedCountry = countries.find((c) =>
            cleaned.startsWith(c.code.replace("-", ""))
        );

        if (matchedCountry) {
            return {
                countryId: matchedCountry.countryId,
                mobileNumber: cleaned.substring(
                    matchedCountry.code.replace("-", "").length
                ),
            };
        }

        return {
            countryId: "",
            mobileNumber: cleaned,
        };
    };

    createInvestor = async () => {
        const validation = this.validateMobileByCountry(
            this.state.countryId,
            this.state.mobilenum
        );

        if (!validation.valid) {
            this.setState({
                mobileError: validation.message,
            });
            toast.error(validation.message, {
                position: "top-center",
                autoClose: 2000,
            });
            return;
        }
        const loggedinUser = getSecureItem("loggedinUser");
        const headers = {
            Authorization: "Bearer " + getSecureItem("token"),
        };

        const payload = {
            firstName: this.state.fname,
            lastName: this.state.lname,
            businessName: this.state.businessName || null,
            gender: this.state.gender || null,
            mobile: this.state.mobilenum || null,
            landlinePhone: this.state.landline || null,
            email: this.state.emailid || null,
            dateOfBirth: this.state.dob || null,
            address: this.state.address || null,
            city: this.state.city || null,
            province: this.state.province || null,
            zipcode: this.state.zipcode || null,
            workingStatus: this.state.workingStatus || null,
            description: this.state.investorDescription || null,
            companyId: loggedinUser.companyId,
            countryId: this.state.countryId || null,
            createdByUserId: loggedinUser.userId,
            updatedByUserId: loggedinUser.userId,
        };

        if (this.state.investorId) payload.investorId = this.state.investorId;

        let formData = new FormData();
        formData.append("payload", JSON.stringify(payload));

        if (this.state.file) {
            formData.append("investorPic", this.state.file);
        }

        const isUpdate = !!this.state.investorId;
        const apiUrl = isUpdate ? `${BaseUrl}/investor/putInvestor` : `${BaseUrl}/investor/postInvestor`;
        const method = isUpdate ? axios.put : axios.post;

        method(apiUrl, formData, { headers })
            .then(async (resp) => {
                if (resp.data?.status || resp.data?.message) {
                    toast.success(resp.data?.message || "Investor saved successfully!", {
                        position: "top-center",
                        autoClose: 2000,
                    });

                    // ✅ Get investorId — either existing or from new investor response
                    const investorId = this.state.investorId || resp.data?.data?.investorId;

                    if (investorId) {
                        // ✅ Set investorId in state if it's new (needed by createInvestment)
                        if (!this.state.investorId) {
                            await new Promise((resolve) => this.setState({ investorId }, resolve));
                        }

                        // ✅ Save all valid investments — create new, update existing
                        for (const inv of this.state.investments) {
                            if (inv.investedAmount && inv.investedDate) {
                                if (inv.investmentId) {
                                    await this.updateInvestment(inv);
                                } else {
                                    await this.createInvestment(inv);
                                }
                            }
                        }
                    }

                    // ✅ Redirect after everything is saved
                    this.props.history.push("/viewInvestor");

                } else {
                    toast.error(resp.data?.message || "Error saving investor", {
                        position: "top-center",
                        autoClose: 2000,
                    });
                }
            })
            .catch((err) => {
                if (err.request.status === 413) {
                    toast.error("File size should be less than 1 Mb", {
                        position: "top-center",
                        autoClose: 2000,
                    });
                } else {
                    toast.error(err.response?.data?.message || "Server error", {
                        position: "top-center",
                        autoClose: 2000,
                    });
                }
            });
    };

    createInvestment = async (investment) => {
        const loggedinUser = getSecureItem("loggedinUser");
        const headers = { Authorization: "Bearer " + getSecureItem("token") };

        const payload = {
            investorId: this.state.investorId,
            investedAmount: investment.investedAmount,
            investedDate: investment.investedDate,
            description: investment.investmentDescription,
            accountId: investment.accountId || null,
            companyId: loggedinUser.companyId,
            createdByUserId: loggedinUser.userId,
            updatedByUserId: loggedinUser.userId,
        };

        try {
            const resp = await axios.post(
                BaseUrl + "/investment/postInvestment",
                payload,
                { headers }
            );
            this.openResponseDialog("Investment Added Successfully", "success");
            return resp.data;
        } catch (err) {
            this.openResponseDialog(
                err.response?.data?.message || "Error adding investment",
                "error"
            );
        }
    };

    updateInvestment = async (investment) => {
        const loggedinUser = getSecureItem("loggedinUser");
        const headers = { Authorization: "Bearer " + getSecureItem("token") };

        const payload = {
            investmentId: investment.investmentId,
            investorId: this.state.investorId,
            companyId: loggedinUser.companyId,
            investedAmount: investment.investedAmount,
            investedDate: investment.investedDate,
            accountId: investment.accountId || null,
            description: investment.investmentDescription,
            updatedByUserId: loggedinUser.userId,
        };

        try {
            const resp = await axios.put(
                BaseUrl + "/investment/putInvestment",
                payload,
                { headers }
            );
            this.openResponseDialog("Investment Updated Successfully", "success");
            return resp.data;
        } catch (err) {
            this.openResponseDialog(
                err.response?.data?.message || "Error updating investment",
                "error"
            );
        }
    };

    deleteInvestment = async (investmentId) => {
        const loggedinUser = getSecureItem("loggedinUser");
        const headers = { Authorization: "Bearer " + getSecureItem("token") };

        try {
            await axios.delete(
                BaseUrl + `/investment/deleteInvestment/${investmentId}`,
                { headers }
            );

            toast.success("Investment Deleted");

            this.setState({
                investments: this.state.investments.filter(
                    (inv) => inv.investmentId !== investmentId
                ),
            });
        } catch (err) {
            toast.error(err.response?.data?.message || "Error");
        }
    };

    removeLocalInvestment = (index) => {
        this.setState((prev) => ({
            investments: prev.investments.filter((_, i) => i !== index),
        }));
    };

    handleRadioChange = (event) => {
        this.setState({ gender: event.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { fname, lname } = this.state;

        if (fname && lname) {
            this.createInvestor();
        }
    };

    render() {
        const { t } = this.props;
        const { countriesData, countryId, investments, investorId } =
            this.state;
        let file = this.state.file;
        file.fieldname = "investorPic";
        file.customerId = this.props.location.params;
        file.createdByUserId = parseInt(getSecureItem("loggedinUser")?.userId);
        file.updatedByUserId = parseInt(getSecureItem("loggedinUser")?.userId);

        let $imagePreview = this.state.imagePreviewUrl ? (
            <img src={this.state.imagePreviewUrl} />
        ) : (
            <div className="previewText">
                <img
                    src={userdefault}
                    className="iconButton"
                    style={{ width: "75px" }}
                />
            </div>
        );

        const filteredDataAccounts = this.getFilteredAccounts();

        return (
            <div>
                <Sidebar />
                <div style={{ textAlign: "center", marginTop: "15px" }}>
                    <div>
                        {this.props.location?.state?.investor ? (
                            <h3 className="Fonts headFontSize" style={{ marginLeft: "45px" }}>
                                <span className="backLink">View</span> / Update Investor Info{" "}
                            </h3>
                        ) : (
                            <h3 className="Fonts headFontSize" style={{ marginLeft: "45px" }}>
                                <span className="backLink">Add Investor Info</span>{" "}
                            </h3>
                        )}
                    </div>
                </div>
                <div className="addInvestorComponent">
                    <Card className="cardDiv">
                        <div className="previewComponent">
                            <form onSubmit={this.handleSubmit} className="investorForm">
                                <div className="flexRowColumn">
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">First Name *</h6>

                                        <div className={"form-group"} style={{ marginTop: "10px" }}>
                                            <Input
                                                type="text"
                                                required
                                                className="form-control"
                                                onClick={this.firstNameBox}
                                                name="firstName"
                                                placeholder="First Name"
                                                style={{ height: "41px", border: this.state.firstName }}
                                                value={this.state.fname}
                                                onChange={(e) =>
                                                    this.setState({
                                                        fname: e.target.value.replace(/[^A-Za-z ]/g, ""),
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="numaricTextField width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Last Name *</h6>
                                        <div className={"form-group"} style={{ marginTop: "10px" }}>
                                            <Input
                                                type="text"
                                                required
                                                className="form-control"
                                                onClick={this.lastNameBox}
                                                name="lastName"
                                                placeholder="Last Name"
                                                style={{ height: "41px", border: this.state.lastName }}
                                                value={this.state.lname}
                                                onChange={(e) =>
                                                    this.setState({
                                                        lname: e.target.value.replace(/[^A-Za-z ]/g, ""),
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="flexRowColumn">
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Business Name</h6>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            onClick={this.businessNameBox}
                                            name="businessName"
                                            placeholder="Business Name"
                                            style={{
                                                height: "41px",
                                                border: this.state.businessNameBox,
                                            }}
                                            value={this.state.businessName}
                                            onChange={(e) =>
                                                this.setState({ businessName: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="numaricTextField width50100">
                                        <h6 className="InputLabel Fonts SizeFont">
                                            Working Status
                                        </h6>
                                        <Select
                                            fullWidth
                                            style={{
                                                height: "41px",
                                                border: this.state.workingStatusBox,
                                            }}
                                            onClick={this.workingStatusBox}
                                            value={this.state.workingStatus}
                                            onChange={(e) =>
                                                this.setState({ workingStatus: e.target.value })
                                            }
                                        >
                                            <MenuItem value="employee">Employee</MenuItem>
                                            <MenuItem value="government employee">
                                                Government Employee
                                            </MenuItem>
                                            <MenuItem value="private sector employee">
                                                Private Employee
                                            </MenuItem>
                                            <MenuItem value="unemployed">Unemployed</MenuItem>
                                            <MenuItem value="student">Student</MenuItem>
                                            <MenuItem value="owner">Owner</MenuItem>
                                        </Select>
                                    </div>
                                </div>
                                <div className="flexRowColumn">
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Phone *</h6>
                                        <div className="form-group">
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Select
                                                    value={this.state.countryId || ""}
                                                    className="selectCC"
                                                    required
                                                    style={{
                                                        height: "41px",
                                                        borderRight: "none",
                                                        border: this.state.countryBoxColour,
                                                        borderRadius: "unset",
                                                        borderTopLeftRadius: "5px",
                                                        borderBottomLeftRadius: "5px",
                                                    }}
                                                    onChange={(e) => {
                                                        const countryId = e.target.value;

                                                        const validation = this.validateMobileByCountry(
                                                            countryId,
                                                            this.state.mobilenum
                                                        );

                                                        this.setState({
                                                            countryId,
                                                            mobileError: validation.valid
                                                                ? ""
                                                                : validation.message,
                                                        });
                                                    }}
                                                    onClick={this.phoneBox}
                                                >
                                                    {countriesData?.map((option, i) => (
                                                        <MenuItem key={i} value={option?.countryId}>
                                                            +{option?.code}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <Input
                                                    type="text"
                                                    pattern="[0-9]*"
                                                    required
                                                    className="form-control numberInputCC"
                                                    placeholder="Enter mobile number"
                                                    value={this.state.mobilenum}
                                                    style={{
                                                        height: "41px",
                                                        border: this.state.phoneBox,
                                                    }}
                                                    onClick={this.phoneBox}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/\D/g, "");

                                                        const validation = this.validateMobileByCountry(
                                                            this.state.countryId,
                                                            value
                                                        );

                                                        this.setState({
                                                            mobilenum: value,
                                                            mobileError: validation.valid ? "" : validation.message,
                                                        });
                                                    }}
                                                />
                                            </div>
                                            {this.state.mobileError && (
                                                <div
                                                    style={{
                                                        color: "red",
                                                        fontSize: "12px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    {this.state.mobileError}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">
                                            Landline Phone
                                        </h6>
                                        <Input
                                            type="text"
                                            pattern="[0-9]*"
                                            className="form-control numberInputCC"
                                            placeholder="Enter Landline number"
                                            value={this.state.landline}
                                            style={{ height: "41px", border: this.state.landLineBox }}
                                            onClick={this.landLineBox}
                                            onChange={(e) =>
                                                this.setState({ landline: e.target.value })
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="flexRowColumn">
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">
                                            {t("AddCustomer.gen")}
                                        </h6>
                                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                                            <div className="radio-item radioButton">
                                                <input
                                                    type="radio"
                                                    value="male"
                                                    checked={this.state.gender === "male"}
                                                    onChange={this.handleRadioChange}
                                                />
                                                <div className="Fonts">Male</div>
                                            </div>

                                            <div className="radio-item radioButton">
                                                <input
                                                    type="radio"
                                                    value="female"
                                                    checked={this.state.gender === "female"}
                                                    onChange={this.handleRadioChange}
                                                />
                                                <div className="Fonts">Female</div>
                                            </div>

                                            <div className="radio-item radioButton">
                                                <input
                                                    type="radio"
                                                    value="transgender"
                                                    checked={this.state.gender === "transgender"}
                                                    onChange={this.handleRadioChange}
                                                />
                                                <div className="Fonts">Transgender</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Date of Birth</h6>
                                        <Input
                                            type="date"
                                            value={this.state.dob}
                                            style={{
                                                height: "41px",
                                                border: this.state.dobBox,
                                            }}
                                            onChange={(e) => this.setState({ dob: e.target.value })}
                                            onClick={this.dobBox}
                                        />
                                    </div>
                                </div>

                                <div className="flexRowColumn">
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Country</h6>
                                        <Select
                                            value={countryId}
                                            className="width50100"
                                            style={{
                                                height: "41px",
                                                border: this.state.countryBox,
                                            }}
                                            onChange={(e) =>
                                                this.setState({ countryId: e.target.value })
                                            }
                                            onClick={this.countryBox}
                                        >
                                            {countriesData?.map((option, i) => (
                                                <MenuItem
                                                    key={i}
                                                    value={option?.countryId}
                                                    onChange={(e) =>
                                                        this.setState({ countryId: e.target.value })
                                                    }
                                                >
                                                    {option?.Country}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Email</h6>
                                        <Input
                                            placeholder="investor@example.com"
                                            value={this.state.emailid}
                                            onChange={this.validEmail}
                                            style={{ height: "41px", border: this.state.emailBox }}
                                            onClick={this.emailBox}
                                        />
                                    </div>
                                </div>

                                <div className="flexRowColumn">
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Address</h6>
                                        <Input
                                            placeholder="Enter Address"
                                            value={this.state.address}
                                            onChange={(e) =>
                                                this.setState({ address: e.target.value })
                                            }
                                            style={{ height: "41px", border: this.state.addressBox }}
                                            onClick={this.addressBox}
                                        />
                                    </div>

                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">City</h6>
                                        <Input
                                            placeholder="Enter City"
                                            value={this.state.city}
                                            onChange={(e) => this.setState({ city: e.target.value })}
                                            style={{ height: "41px", border: this.state.cityBox }}
                                            onClick={this.cityBox}
                                        />
                                    </div>
                                </div>

                                <div className="flexRowColumn">
                                    <div className="textFieldStyle width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Province</h6>
                                        <Input
                                            placeholder="Enter Province"
                                            value={this.state.province}
                                            onChange={(e) =>
                                                this.setState({ province: e.target.value })
                                            }
                                            style={{ height: "41px", border: this.state.provinceBox }}
                                            onClick={this.provinceBox}
                                        />
                                    </div>

                                    <div className="numaricTextField width50100">
                                        <h6 className="InputLabel Fonts SizeFont">Zip Code</h6>
                                        <Input
                                            placeholder="Enter Zip Code"
                                            value={this.state.zipcode}
                                            onChange={(e) =>
                                                this.setState({ zipcode: e.target.value })
                                            }
                                            style={{ height: "41px", border: this.state.zipCodeBox }}
                                            onClick={this.zipCodeBox}
                                        />
                                    </div>
                                </div>

                                <div className="previewComponent">
                                    <div
                                        className="flexRowColumn"
                                        style={{
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            paddingTop: "15px",
                                        }}
                                    >
                                        <div>
                                            <p className="Fonts">Photo</p>
                                            <div className="imgPreview">{$imagePreview}</div>
                                            <input
                                                className="fileInput"
                                                type="file"
                                                accept="image/png, image/jpeg"
                                                onChange={this._handleImageChange}
                                                id="icon-button-file"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="textFieldStyle width50100">
                                    <h6 className="InputLabel Fonts SizeFont">
                                        Investor Description
                                    </h6>
                                    <Input
                                        placeholder="Investor Description"
                                        value={this.state.investorDescription}
                                        onChange={(e) =>
                                            this.setState({ investorDescription: e.target.value })
                                        }
                                        style={{
                                            height: "41px",
                                            border: this.state.investorDescriptionBox,
                                        }}
                                        onClick={this.investorDescriptionBox}
                                    />
                                </div>
                            </form>
                            {investorId && (
                                <div style={{ marginTop: "25px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "2rem" }}>
                                        <h3 className="Fonts headFontSize">Investments</h3>
                                        <Button
                                            style={{ marginTop: "10px", backgroundColor: "#00D95E", color: "#fff", textTransform: "none" }}
                                            onClick={() => {
                                                const newInv = { investedAmount: "", investedDate: "", investmentDescription: "", accountId: null };
                                                this.setState((prev) => ({
                                                    investments: [...prev.investments, newInv],
                                                    // editingIndex: prev.investments.length, // ✅ new row opens in edit mode
                                                }));
                                            }}
                                        >
                                            + Add Investment
                                        </Button>
                                    </div>

                                    {investments.map((inv, index) => {
                                        // const isEditing = this.state.editingIndex === index;

                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "20px",
                                                    marginBottom: "20px",
                                                    padding: "10px 20px",
                                                    // opacity: isEditing ? 1 : 0.7,
                                                }}
                                            >
                                                <Input
                                                    placeholder="Amount"
                                                    value={inv.investedAmount}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === "" || /^\d*\.?\d*$/.test(value)) {  // ✅ numeric only
                                                            this.handleInvestmentChange(index, "investedAmount", value);
                                                        }
                                                    }}
                                                    // disabled={!isEditing}  // ✅ locked until edit clicked
                                                    style={{ minWidth: "160px", border: "1px solid #D4D4D5" }}
                                                />

                                                <Input
                                                    type="date"
                                                    value={inv.investedDate}
                                                    onChange={(e) => this.handleInvestmentChange(index, "investedDate", e.target.value)}
                                                    // disabled={!isEditing}  // ✅ locked until edit clicked
                                                    style={{ minWidth: "160px", border: "1px solid #D4D4D5" }}
                                                />

                                                <Select
                                                    value={inv.accountId || ""}  // ✅ per-row accountId, not global
                                                    style={{ minWidth: "160px", border: "1px solid #D4D4D5" }}
                                                    onChange={(e) => this.handleInvestmentChange(index, "accountId", e.target.value)}  // ✅ updates that row only
                                                    // disabled={!isEditing}
                                                >
                                                    {filteredDataAccounts?.map((option) => (
                                                        <MenuItem key={option?.value} value={option?.value}>
                                                            {option?.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>

                                                <Input
                                                    placeholder="Description"
                                                    value={inv.investmentDescription}
                                                    onChange={(e) => this.handleInvestmentChange(index, "investmentDescription", e.target.value)}
                                                    // disabled={!isEditing}  // ✅ locked until edit clicked
                                                    style={{ minWidth: "260px", border: "1px solid #D4D4D5" }}
                                                />

                                                {/* {!isEditing ? (
                                                    <EditIcon
                                                        style={{ cursor: "pointer", color: "#000" }}
                                                        onClick={() => this.setState({ editingIndex: index })}  // ✅ unlocks row
                                                    />
                                                ) : (
                                                    <DoneIcon
                                                        style={{ cursor: "pointer", color: "green" }}
                                                        onClick={() => this.setState({ editingIndex: null })}  // ✅ just locks row, NO API call
                                                    />
                                                )} */}

                                                <DeleteIcon
                                                    style={{ cursor: "pointer", color: "red" }}
                                                    onClick={() => this.openDeleteDialog(index)}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            <div style={{ textAlign: "end", marginTop: 20 }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className="savebutton btnSizeFont Fonts"
                                    onClick={this.createInvestor}
                                >
                                    {this.state.investorId
                                        ? "Update Investor"
                                        : "Create Investor"}
                                </Button>
                            </div>
                        </div>
                    </Card>
                </div>
                <Dialog
                    open={this.state.openDeleteDialog}
                    onClose={this.closeDeleteDialog}
                    aria-labelledby="delete-dialog-title"
                    aria-describedby="delete-dialog-description"
                >
                    <DialogTitle id="delete-dialog-title">{"Confirm Delete"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="delete-dialog-description">
                            Are you sure you want to delete this investment? This action
                            cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeDeleteDialog} color="primary">
                            Cancel
                        </Button>
                        <Button
                            onClick={this.confirmDeleteInvestment}
                            color="error"
                            autoFocus
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.responseDialogOpen}
                    onClose={this.closeResponseDialog}
                    aria-labelledby="response-dialog-title"
                    aria-describedby="response-dialog-description"
                >
                    <DialogTitle id="response-dialog-title">
                        {this.state.responseDialogType === "success" ? "Success" : "Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="response-dialog-description">
                            {this.state.responseDialogMessage}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.closeResponseDialog}
                            color="primary"
                            autoFocus
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withNamespaces()(AddInvestor);
